module.exports = __webpack_public_path__ + "static/6-aeaffafe7dcdca7b822735907a2983d2.jpg";